module.exports = __webpack_public_path__ + "static/img/pay_fail_joychat.d20d20b4.png";